import './App.css';
import { TodoWrapper } from './components/TodoWrapper.js';

function App() {
  return (
    <div className="App">
      <TodoWrapper />
    </div>
  );
}

export default App;
